import { useState, useEffect } from 'react';

export const useClientOnly = () => {
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {

        setHasMounted(true);
    }, []);

    return hasMounted;
};
